import DeleteIcon from "@mui/icons-material/Delete";
import { Badge, BadgeProps, IconProps } from "@mui/material";
import { styled } from "@mui/material/styles";

export const InfoToolbarIconBadge = styled(Badge)<BadgeProps>(() => ({
  "& .MuiBadge-badge": {
    fontSize: "0.55rem",
    padding: "0px",
    height: "15px",
    minWidth: "15px",
  },
}));

export const ToolbarDeleteIcon = styled(DeleteIcon)<IconProps>(() => ({
  "& .MuiIconButton-root": {
    padding: "10px",
  },
}));
